// Custom backend for i18next to load translations directly.
// When in edit mode, it merges translations from the static files and the database.
// Otherwise, it just uses the translation files.
import i18next from 'i18next';
import enTranslations from './translations/locales/en/translation.json';
import ptBRTranslations from './translations/locales/pt-BR/translation.json';
import _ from 'lodash';

// Static translations object
const translations = {
  en: {
    translation: enTranslations,
  },
  'pt-BR': {
    translation: ptBRTranslations,
  },
};

class HybridBackend {
  constructor(services, backendOptions = {}) {
    this.init(services, backendOptions);
    this.isEditMode = false;
    this.databaseTranslations = {};
  }

  init(services, backendOptions = {}) {
    this.services = services;
    this.options = backendOptions;
  }

  setEditMode(isEditMode) {
    this.isEditMode = isEditMode;
  }

  read(language, namespace, callback) {
    try {
      if (translations[language] && translations[language][namespace]) {
        if (this.isEditMode) {
          // We only use the database translations in edit mode.
          const mergedTranslations = _.defaultsDeep({}, this.databaseTranslations[language], translations[language][namespace]);
          callback(null, mergedTranslations);
        } else {
          // Return the static translation data
          callback(null, translations[language][namespace]);
        }
      } else {
        // Return error if translation not found
        callback(new Error(`Translation not found for ${language}/${namespace}`), null);
      }
    } catch (error) {
      callback(error, null);
    }
  }

  async setDatabaseTranslations(language, translations) {
    this.databaseTranslations[language] = translations;
    await i18next.reloadResources([language]);
    i18next.changeLanguage(language); // do this to trigger the translations to rerender.
  }
}

// Static method required by i18next
HybridBackend.type = 'backend';

export default HybridBackend;
